import styled from 'styled-components';
import '../../styles/GlobalThemeStyle';

import { Modal, Card } from 'antd';
import Lottie from 'lottie-react';

export const XLottie = styled(Lottie)`
	position: relative;
	background: transparent;
	width: 80%;
`;

export const XCard = styled(Card)`
	.ant-card-body {
		height: 510px;
		position: relative;

		.overlay-container {
			height: 100%;
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: flex-start;

			h2 {
				font-size: 12px;
				color: #202020;
				text-align: center;
			}

			.progress-bar-container {
				width: 100%;
				height: 4px;
				background-color: rgba(2, 117, 155, 0.1);
				border-radius: 20px;
				overflow: hidden;
			}

			.progress-bar {
				height: 80%;
				background: #82c446 !important;
				border-radius: 4px;
				transition: width 0.5s ease-in-out;
			}
			.analysis-content {
				h2 {
					margin: 0px;
					color: ${({ theme }) => theme.CQColors.themeColor2};
					font-size: 12px;
					font-weight: 500;
					line-height: 12px;
					margin-bottom: 12px;
				}
			}
			.percentage-text {
				font-size: 14px;
				font-weight: 500;
				color: ${({ theme }) => theme.CQColors.themeColor2};
				text-align: center;
			}
			.analysis-list {
				border: 1px solid #f0f0f0;
				border-radius: 16px;
				padding: 15px;
				width: 300px;
				margin-top: 10px;
			}
		}
	}
`;

export const XModalAnimation = styled(Modal)`
	.ant-modal-close {
		top: -5px !important;
		inset-inline-end: 0px !important;
		display: none;
	}
	.ant-card {
		border: none;
		background: transparent;
		box-shadow: none;
	}
	.ant-modal-footer {
		margin: 0px;
	}
	.ant-modal-content {
		background: transparent !important;
		box-shadow: none;
		padding: 80px 60px;
		@media only screen and (max-width: 511.99px) {
			padding: 15px !important;
		}
		&:after {
			position: absolute;
			left: 39%;
			right: 0;
			top: 45px;
			content: '';
			display: block;
			width: 114px;
			height: 51px;
			@media only screen and (max-width: 511.99px) {
				top: -20px;
				left: 30%;
			}
		}
	}
	.ant-card-body {
		background: #fff;
		border-radius: 40px;
		ul {
			margin: 0px;
			padding: 0px;
			min-height: 200px;
		}
		ul li {
			display: list-item;
			list-style-type: none;
			font-weight: 400;
			font-size: 12px;
			line-height: 12px;
			margin-bottom: 12px;
			align-items: center;
			display: flex;
			@media only screen and (max-width: 511.99px) {
				line-height: 16px;
			}
			&:last-child {
				margin-bottom: 0px;
			}
			span {
				position: absolute;
				left: 30px;
				width: 30px;
				height: 30px;
				border-radius: 30px;
				text-align: center;
				@media only screen and (max-width: 511.99px) {
					line-height: 30px;
				}
			}
			span.status-icon {
				position: inherit;
				// right: 30px !important;
				// left: auto !important;
				width: 25px;
				height: 25px;
				border-radius: 30px;
				text-align: center;
				@media only screen and (max-width: 511.99px) {
					line-height: 25px;
				}
				background: transparent !important;
			}
		}
		ul li.active {
			color: #008542;
			transition: color 3s;
			span {
				background: #008542;
				transition: background-color 3s;
			}
		}
		ul li.inprocess {
			color: #e5aa11;
			transition: color 3s;
			span {
				background: #e5aa11;
				transition: background-color 3s;
			}
		}
	}
`;

export const XLottieLoader = styled.section`
	width: 100%;
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	right: 0;
	top: 20px;
	bottom: 0;
`;
